import React from "react";
import styles from "./RiskAssessmentMatrixShared.module.css";

export default function RiskAssessmentMatrixTable({ likelihoods, consequences, risks }) {
  return (
    <div style={{ border: "1px solid #E2E8F0", borderRadius: "8px", overflow: "hidden" }}>
      <table className={styles.ramTable}>
        <colgroup>
          <col style={{ width: "140px" }} />
          {consequences.map((_, idx) => (
            <col key={idx} style={{ width: `calc((100% - 140px) / ${consequences.length})` }} />
          ))}
        </colgroup>
        <thead>
          <tr>
            <th className={styles.ramTableHeaderLikelihood} rowSpan={2}>
              Likelihood
            </th>
            <th className={styles.ramTableHeaderConsequence} colSpan={consequences.length}>
              Consequence
            </th>
          </tr>
          <tr>
            {consequences.map((consequence) => (
              <th key={consequence.id || consequence.value} className={styles.ramTableHeaderConsequenceCol}>
                {consequence.name || ""}{consequence.value ? ` (${consequence.value})` : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {likelihoods.map((likelihood) => (
            <tr key={likelihood.id || likelihood.value}>
              <td className={styles.ramTableBodyLikelihood}>
                {likelihood.name} ({likelihood.value})
              </td>
              {consequences.map((consequence) => {
                const score = Number(likelihood.value) * Number(consequence.value);
                const associatedRisk = risks.find(
                  (risk) =>
                    Number(risk.risk_rating_high_value) >= score &&
                    Number(risk.risk_rating_low_value) <= score
                );
                return (
                  <td
                    key={`${likelihood.id || likelihood.value}-${consequence.id || consequence.value}`}
                    className={styles.ramTableBodyCell}
                    style={{
                      backgroundColor: associatedRisk && associatedRisk.risk_colours ? associatedRisk.risk_colours : "#fff",
                      color: associatedRisk && associatedRisk.risk_colours && "#7F1D1D" === associatedRisk.risk_colours ? "#fff" : "#1E293B"
                    }}
                  >
                    {score}{associatedRisk ? ` (${associatedRisk.risk_rating_label})` : ""}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
